import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import './style.css';

import { App } from './pages';

const container = document.getElementById('app-root');
const root = createRoot(container!);

root.render(
    <StrictMode>
        <App />
    </StrictMode>,
);
